import React from 'react';
import * as mobx from 'mobx';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";

import {determineDefaultSelectionForReply} from './index';
import {SchedulePageSummary} from './SchedulePageSummary';
import {publish} from "../api";
import {ToastService} from "../../../../components/toasts/Toasts";
import {PublishingDestinationSelector} from "../../PublishingDestinationSelector";
import sessionStore from "../../../../services/session/SessionStore"
import {TimeAgoIfRecent} from "../../components/TimeAgoIfRecent";

@observer
export default class PostLiker extends React.Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    onAdd: PropTypes.func
  };

  state = {
    selectedOption: undefined,
    publishing: false
  };

  componentDidMount() {
    const post = this.props.item;
    const accountId = post ? post.accountId : (sessionStore.account.accountId || sessionStore.user.accountId);
  }

  render() {
    const {
      item,
      onAdd,
      ...props
    } = this.props;

    const {selectedOption, publishing} = this.state;

    const post = {
      ...item,
      scheduledResponses: item.scheduledResponses
    };
    const usePageIds = post.provider === 'Facebook';
    const accountId = post ? post.accountId : (sessionStore.account.accountId || sessionStore.user.accountId);

    const alreadyLiked = {};
    let excludeOptions = [];
    const liked = post.scheduledResponses.filter(x => x.publishType === 'Like');
    liked.forEach(x => {
      if (usePageIds) {
        alreadyLiked[x.remotePageId] = true;
        excludeOptions.push({key: x.remotePageId})
      } {
        alreadyLiked[x.chatterUserAccountId] = true;
        excludeOptions.push({key: x.chatterUserAccountId})
      }
    });

    const actionLabel = post.provider === 'Twitter' ? 'Favorite' : 'Like';
    const orDefault = (selectedOption === 'DEFAULT' || !selectedOption)
      ? determineDefaultSelectionForReply(
          {
            post,
            exclude: alreadyLiked
          }
        )
      : selectedOption;

    return (
      <div {...props}>
        <div style={{display: 'flex'}}>
          <div style={{flex: 1}}>
            <PublishingDestinationSelector
              width={post.provider === 'Twitter' ? '150px' : '200px'}
              excludeGroups={true}
              provider={post.provider}
              accountId={accountId}
              selected={orDefault ? [orDefault] : []}
              onSelected={o => {
                return this.setState({selectedOption: o})
              }}
              noResultsText={
                liked.length ? 'All users have already liked this post' :
                  `No ${post.provider} users available. Add users on the settings page`
              }
              excludeOptions={excludeOptions}
            />
          </div>
          <button
            type="button"
            style={{lineHeight: '22px', marginLeft: '5px'}}
            className="btn btn-secondary"
            disabled={!orDefault || publishing}
            onClick={() => {
              const chatterUserAccountId = orDefault.userAccountId
                ? orDefault.userAccountId
                : orDefault.id; // Format: <PageType>:<RemoteId>
              const remotePageId = orDefault.remoteId
                ? orDefault.remoteId
                : orDefault.remoteIds[0];

              let payload = {
                provider: post.provider,
                inReplyTo: post.postId,
                chatterUserAccountId,
                remotePageId,
                publishType: 'Like'
              };

              this.setState({publishing: true});
              return publish(payload).then((postedLike) => {
                ToastService.success(`${actionLabel} successful`);
                onAdd && onAdd(postedLike);
                this.setState({publishing: false});
              }).catch((e) => {
                if (e.message) {
                  ToastService.error("Failed to submit", e.message);
                } else {
                  ToastService.error(`Failed to ${actionLabel}`);
                }
              });

            }}>
            {actionLabel}
          </button>
        </div>
        <div>
          {
            liked.length ? <h6 style={{marginTop: '10px'}}>Like History</h6> : undefined
          }
          {
            liked.slice().reverse().map((x, i) => {
              return (
                <div
                  className="clearfix d-flex align-items-center justify-content-between"
                  key={x._id && x._id.$oid || i.toString()}
                >
                  <SchedulePageSummary schedule={x} />&nbsp;
                  <span className="text-muted">
                    { x.scheduledTime ? <TimeAgoIfRecent minDays={1} date={x.scheduledTime}/> : 'just now' }
                  </span>
                </div>
              );
            })
          }
        </div>
      </div>
    );
  }
}
